// @flow

import React from 'react';
import ProgressWrapper from './ProgressWrapper';
import ProgressBar from './ProgressBar';

type Props = {
  value: Number,
  color?: String,
};

export default function Progress(props: Props) {
  return (
    <ProgressWrapper>
      <ProgressBar {...props} />
    </ProgressWrapper>
  );
}
